import Typography from '@mui/material/Typography';
import { Link } from '@reach/router';
import { policyStreamPaths } from '../policyStreamConstants';
import { styled } from '@mui/material';

export const AgreeToTosComponent = () => {
  return (
    <AgreeText>
      By continuing, you agree to the{' '}
      <Link to={policyStreamPaths.tos.url}>terms of use</Link>.
    </AgreeText>
  );
};

const AgreeText = styled(Typography)(({ theme }) => {
  return { ...theme.typography.subtitle1, marginTop: theme.spacing(2) };
});
